import { ExclamationTriangleIcon, ArrowUturnLeftIcon, ClockIcon } from '@heroicons/react/24/outline';

// Shared between the category-tile landing page (AbsenceReportingDashboard)
// and the per-category detail page (AbsenceReportingCategory) — one source
// of truth for the report_type <-> URL slug <-> label mapping.
export const CATEGORIES = [
  { slug: 'absence-reporting', label: 'Absence Reporting', reportType: 'Report Absence', icon: ExclamationTriangleIcon },
  { slug: 'return-to-work', label: 'Return to Work', reportType: 'Return to Work', icon: ArrowUturnLeftIcon },
  { slug: 'report-late', label: 'Report Late', reportType: 'Report Late', icon: ClockIcon },
];

export function categoryBySlug(slug) {
  return CATEGORIES.find((c) => c.slug === slug) || null;
}

// The status the toggle is confirming, per category — a manager shouldn't
// deep-link into the FSM form for someone who's no longer in that state
// without actively confirming it first.
export const STATUS_CONFIRM_LABEL = {
  'Report Absence': 'still absent',
  'Report Late': 'still late',
  'Return to Work': 'ready to return to work',
};

// Report attachment button copy (AbsenceReportingDashboard.jsx) — same
// labels as nano-fibre-fsm's own AbsenceReportingList.jsx, so a record's
// report reads the same wherever it's opened from.
export const REPORT_TYPE_LABEL = {
  'Report Absence': 'Absence Report',
  'Report Late': 'Late Report',
  'Return to Work': 'Return to Work Report',
};
